/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesGroupsApplicationGroupSlotsGroupSlotResponse } from '../model/modulesGroupsApplicationGroupSlotsGroupSlotResponse';
import { ModulesGroupsApplicationGroupingsGroupingsResponse } from '../model/modulesGroupsApplicationGroupingsGroupingsResponse';
import { ModulesGroupsApplicationGroupsGroupResponse } from '../model/modulesGroupsApplicationGroupsGroupResponse';
import { ModulesGroupsEndpointsContractsGroupSlotsCreateGroupSlotRequestModel } from '../model/modulesGroupsEndpointsContractsGroupSlotsCreateGroupSlotRequestModel';
import { ModulesGroupsEndpointsContractsGroupsCreateGroupRequest } from '../model/modulesGroupsEndpointsContractsGroupsCreateGroupRequest';
import { ModulesGroupsEndpointsContractsGroupsUpdateGroupRequestModel } from '../model/modulesGroupsEndpointsContractsGroupsUpdateGroupRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { GroupsServiceInterface }                            from './groups.serviceInterface';


@Injectable()
export class GroupsService implements GroupsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a Group.
     * Gets a Group using the Group identifier.
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupByIdEndpoint(groupId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesGroupsApplicationGroupsGroupResponse>;
    public getGroupByIdEndpoint(groupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesGroupsApplicationGroupsGroupResponse>>;
    public getGroupByIdEndpoint(groupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesGroupsApplicationGroupsGroupResponse>>;
    public getGroupByIdEndpoint(groupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling getGroupByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesGroupsApplicationGroupsGroupResponse>('get',`${this.basePath}/groups/${encodeURIComponent(String(groupId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets one or more Group Slots.
     * Gets one or more Group Slots by the Group identifier.
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupSlotsEndpoint(groupId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesGroupsApplicationGroupSlotsGroupSlotResponse>>;
    public getGroupSlotsEndpoint(groupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesGroupsApplicationGroupSlotsGroupSlotResponse>>>;
    public getGroupSlotsEndpoint(groupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesGroupsApplicationGroupSlotsGroupSlotResponse>>>;
    public getGroupSlotsEndpoint(groupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling getGroupSlotsEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesGroupsApplicationGroupSlotsGroupSlotResponse>>('get',`${this.basePath}/groups/${encodeURIComponent(String(groupId))}/slots`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets player groupings across rounds
     * Returns one row per player with group, tee, and time values pivoted across rounds.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupingsEndpoint(tournamentId?: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesGroupsApplicationGroupingsGroupingsResponse>;
    public getGroupingsEndpoint(tournamentId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesGroupsApplicationGroupingsGroupingsResponse>>;
    public getGroupingsEndpoint(tournamentId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesGroupsApplicationGroupingsGroupingsResponse>>;
    public getGroupingsEndpoint(tournamentId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('tournamentId', <any>tournamentId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesGroupsApplicationGroupingsGroupingsResponse>('get',`${this.basePath}/groupings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets one or more Groups.
     * Gets one or more Groups by querystring parameters. Optionally include related slots with ?include&#x3D;slots. The &#x27;include&#x27; parameter supports comma-separated values (e.g., ?include&#x3D;slots,users) and is case-insensitive.
     * @param tournamentId 
     * @param roundId 
     * @param courseId 
     * @param include 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGroupsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, include?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesGroupsApplicationGroupsGroupResponse>>;
    public getGroupsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, include?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesGroupsApplicationGroupsGroupResponse>>>;
    public getGroupsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, include?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesGroupsApplicationGroupsGroupResponse>>>;
    public getGroupsEndpoint(tournamentId?: string, roundId?: string, courseId?: string, include?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('tournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }
        if (courseId !== undefined && courseId !== null) {
            queryParameters = queryParameters.set('courseId', <any>courseId);
        }
        if (include !== undefined && include !== null) {
            queryParameters = queryParameters.set('include', <any>include);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesGroupsApplicationGroupsGroupResponse>>('get',`${this.basePath}/groups`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Group.
     * Removes a Group using the Group identifier.
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groupsGroupIdDelete(groupId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public groupsGroupIdDelete(groupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public groupsGroupIdDelete(groupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public groupsGroupIdDelete(groupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling groupsGroupIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/groups/${encodeURIComponent(String(groupId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Group.
     * Updates a Group based on the Group idenfier and UpdateGroupRequest.
     * @param groupId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groupsGroupIdPut(groupId: string, body?: ModulesGroupsEndpointsContractsGroupsUpdateGroupRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public groupsGroupIdPut(groupId: string, body?: ModulesGroupsEndpointsContractsGroupsUpdateGroupRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public groupsGroupIdPut(groupId: string, body?: ModulesGroupsEndpointsContractsGroupsUpdateGroupRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public groupsGroupIdPut(groupId: string, body?: ModulesGroupsEndpointsContractsGroupsUpdateGroupRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling groupsGroupIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/groups/${encodeURIComponent(String(groupId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Group.
     * Creates a Group based on the CreateGroupRequest request.
     * @param groupId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groupsGroupIdSlotsPost(groupId: string, body?: ModulesGroupsEndpointsContractsGroupSlotsCreateGroupSlotRequestModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public groupsGroupIdSlotsPost(groupId: string, body?: ModulesGroupsEndpointsContractsGroupSlotsCreateGroupSlotRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public groupsGroupIdSlotsPost(groupId: string, body?: ModulesGroupsEndpointsContractsGroupSlotsCreateGroupSlotRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public groupsGroupIdSlotsPost(groupId: string, body?: ModulesGroupsEndpointsContractsGroupSlotsCreateGroupSlotRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling groupsGroupIdSlotsPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/groups/${encodeURIComponent(String(groupId))}/slots`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Group.
     * Creates a Group based on the CreateGroupRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groupsPost(body?: ModulesGroupsEndpointsContractsGroupsCreateGroupRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public groupsPost(body?: ModulesGroupsEndpointsContractsGroupsCreateGroupRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public groupsPost(body?: ModulesGroupsEndpointsContractsGroupsCreateGroupRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public groupsPost(body?: ModulesGroupsEndpointsContractsGroupsCreateGroupRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/groups`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
